import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";

export const SectionContainer = styling("div")((props) => ({
  margin: "0 auto",
  maxWidth: "1440px",
  padding: "80px 100px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 24px",
  },
}));

export const BoxContainer = styling(Box)({
  display: "flex",
  width: "100%",
});

export const BoxStyled = styling(Box)({});

export const TextStyled = styling(Typography)({});

export const PurpleStyled = styling("span")({
  color: Color.hiredlyPurple,
});

export const ImageStyled = styling("img")({
  objectFit: "contain",

  "@media (max-width: 1280px)": {
    maxHeight: "24px",
  },

  "@media (max-width: 768px)": {
    maxHeight: "50px",
  },
});
